import { withDropdown } from '../Dropdown';
import { Popup } from '../../Popup/desktop/bundle';
export var Dropdown = withDropdown(Popup);
export * from '../Dropdown';
